import React from "react";
import { RxFontStyle } from "react-icons/rx";

const CompanyPreface = () => {
  return (
    <div className="bg-gray-100 py-10 text-justify">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-6">About Us</h1>

        <p className="text-gray-700 leading-relaxed mb-4">
        अनिल इंजीनियर (Anil Engineer),
         उच्च गुणवत्ता वाली तेल निकालने वाली मशीनों (Oil Extraction Machines)
          और ग्राइंडर्स के एक विश्वसनीय निर्माता और आपूर्तिकर्ता हैं। हम अपने ग्राहकों को कुशल,
           टिकाऊ और लागत प्रभावी समाधान प्रदान करने के लिए प्रतिबद्ध हैं। वर्षों के उद्योग अनुभव के साथ,
            हम लघु-स्तरीय व्यवसायों, व्यावसायिक इकाइयों और औद्योगिक 
        अनुप्रयोगों की जरूरतों को पूरा करने वाली मशीनों को डिजाइन और उत्पादित करने में विशेषज्ञ हैं। 
        </p>

        <p className="text-gray-700 leading-relaxed mb-4">
         हमारे उत्पाद उच्च प्रदर्शन, कम रखरखाव और लंबी सेवा जीवन 
         सुनिश्चित करने के लिए प्रीमियम-ग्रेड सामग्री और उन्नत तकनीक का 
         उपयोग करके निर्मित किए जाते हैं। हम ऐसी मशीनें देने के लिए सटीक इंजीनियरिंग
          (precision engineering) पर ध्यान केंद्रित करते हैं जो गुणवत्ता और 
         शुद्धता बनाए रखते हुए अधिकतम आउटपुट प्रदान करती हैं। 
        </p>

        <p className="text-gray-700 leading-relaxed mb-4">
          हम होम, स्मॉल बिजनेस और कमर्शियल उपयोग के लिए डिज़ाइन 
          की गई ऑयल मेकर मशीनों (Oil Maker Machines) के निर्माण में विशेषज्ञ हैं। 
          हमारी मशीनें मूंगफली, सरसों, तिल, नारियल, सूरजमुखी और अन्य विभिन्न तिलहनों से शुद्ध,
           प्राकृतिक तेल निकालने के लिए बनाई गई हैं। कॉम्पैक्ट होम-यूज तेल मशीनों से लेकर उच्च-क्षमता वाली व्यावसायिक और कमर्शियल मॉडल तक, हमारे उत्पाद दक्षता, 
          स्थायित्व और संचालन में आसानी के लिए इंजीनियर किए गए हैं।
           </p>

        <p className="text-gray-700 leading-relaxed mb-4">
          अनिल इंजीनियर में, हम समझते हैं कि गुणवत्तापूर्ण भोजन गुणवत्तापूर्ण सामग्री
           से शुरू होता है। यही कारण है कि हम ऐसे उत्पाद बनाने के लिए जुनूनी हैं जो न केवल शानदार स्वाद देते हैं, बल्कि
          उनका उपयोग करने वालों के स्वास्थ्य और कल्याण का भी समर्थन करते हैं।
        </p>

        <p className="text-gray-700 leading-relaxed mb-4">
         तीन दशकों से अधिक के अनुभव के साथ, हम हर बूंद में उत्कृष्टता प्रदान करने पर केंद्रित हैं, यह सुनिश्चित करते हुए कि प्रत्येक उत्पाद हमारे द्वारा स्वयं और हमारे उपभोक्ताओं के लिए निर्धारित उच्च मानकों पर खरा उतरे। हम अपनी यात्रा जारी रखने, अपने भागीदारों और ग्राहकों के साथ मजबूत संबंध विकसित करने, 
         और एक स्वस्थ तथा अधिक टिकाऊ भविष्य में योगदान देने के लिए तत्पर हैं।
        </p>

        <h2 className="text-xl font-semibold text-center italic mt-8">
       <b style={{ fontFamily: 'Times New Roman',fontSize:"22px"}}>    The Quality inspires trust -</b><b style={{ fontFamily: 'Times New Roman',color: "red",fontSize:"30px"}}> ANIL ENGINEER </b><br /><b style={{ fontFamily: 'Times New Roman',color: "white",fontSize:"20px",marginLeft: "400px", color:"black"}}> The ISO 9001:2015 Certified Co.</b>
            </h2>
      </div>
    </div>
  );
};

export default CompanyPreface;
